import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./Redux/Store/store";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
//import store from "./Redux/Store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

if ('serviceWorker' in navigator && false) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/clearCache.js') // Ensure the path is correct
      .then((registration) => {
        console.log('✅ Service Worker registered with scope:', registration.scope);

        // Check if the Service Worker is controlling the page
        if (navigator.serviceWorker.controller) {
          console.log('✅ Service Worker is active and controlling the page.');
          // Start interval to check every 5 seconds
          function checkVersion() {
            if (navigator.serviceWorker.controller) {
              console.log('🔄 Checking for updates...');
              navigator.serviceWorker.controller.postMessage({ type: 'CHECK_VERSION' });
            }
          }
          let intervalId = setInterval(checkVersion, 5000);

          // Listen for controller change (when a new SW takes over)
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            console.log('♻️ New Service Worker activated. Restarting version check...');
            clearInterval(intervalId);
            intervalId = setInterval(checkVersion, 5000); // Restart interval
          });

          // navigator.serviceWorker.controller.postMessage({ type: 'CHECK_VERSION' });
        }

        // Listen for messages from the service worker
        navigator.serviceWorker.addEventListener('message', (event) => {
          console.log('📩 Message from Service Worker:', event.data);

          if (event.data?.type === 'HARD_REFRESH') {
            window.location.reload(true);
          }
        });
      })
      .catch((error) => {
        console.error('❌ Service Worker registration failed:', error);
      });
  });
}





// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
